export const isNull = (value) => value === '' || value === null || value === undefined;

export const isEmpty = (array) => array.length === 0;